function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M104,696.27a1.16,1.16,0,0,1-1.16-1.17V524.83a1.17,1.17,0,0,1,.57-1l134.47-79.29a1.36,1.36,0,0,1,1.38,0L350.37,510a7.69,7.69,0,0,0,3.91,1.07h42.63a1.21,1.21,0,0,0,.64-2.24L243.46,412.58a9.52,9.52,0,0,0-9.7,0L80.09,508.93a3.9,3.9,0,0,0-1.91,3.35v204.8A3.89,3.89,0,0,0,82.07,721H767.52a2.33,2.33,0,0,0,2.33-2.34v-20a2.33,2.33,0,0,0-2.33-2.33Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M445,424.68a1.33,1.33,0,0,0-1.33,1.34v84a1.33,1.33,0,0,0,1.33,1.33h14.65A1.33,1.33,0,0,0,461,510V481.24a1.34,1.34,0,0,1,1.33-1.34h13.14c17.83,0,26.88-12.73,26.88-27.55s-9.05-27.67-26.88-27.67Zm39.63,27.67c0,7.41-4.53,12.35-11.25,12.35H461.69A.67.67,0,0,1,461,464V440.9a.89.89,0,0,1,.88-.89h11.52C480.14,440,484.67,444.82,484.67,452.35Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M594.74,468.07c0-25.85-13.57-44.82-36.18-44.82s-36.18,19-36.18,44.82,13.44,44.83,36.18,44.83S594.74,493.93,594.74,468.07Zm-54.65,0c0-16.76,6.46-29.36,18.47-29.36,11.76,0,18.35,12.6,18.35,29.36s-6.59,29.37-18.35,29.37C546.55,497.44,540.09,484.71,540.09,468.07Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M651.19,512.9c19.51,0,31.92-11.43,31.92-31.57V426.45a1.77,1.77,0,0,0-1.77-1.77H667.43a1.77,1.77,0,0,0-1.77,1.77v55c0,10.39-5.29,16.11-14.47,16.11s-14.34-5.72-14.34-16.11v-55a1.76,1.76,0,0,0-1.76-1.77H621.17a1.76,1.76,0,0,0-1.76,1.77v54.88C619.41,501.47,631.81,512.9,651.19,512.9Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M728.58,509.35V482a2,2,0,0,1,2-2h6.14a2,2,0,0,1,1.82,1.21l12.29,28.9a2,2,0,0,0,1.82,1.2h14.84a2,2,0,0,0,1.8-2.83l-13.71-29.68a2,2,0,0,1,1-2.63c6-2.68,12.09-9,13.2-20.31,1.67-16.79-11.93-31.21-28.72-31.21H713.24a2,2,0,0,0-2,2v82.68a2,2,0,0,0,2,2H726.6A2,2,0,0,0,728.58,509.35Zm0-68.71a.63.63,0,0,1,.63-.63H741c6.72,0,11.24,4.81,11.24,12.34S747.7,464.7,741,464.7H729.6a1,1,0,0,1-1-1Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M78.14,742.52a3.34,3.34,0,1,1,6.66,0v21.33a.24.24,0,0,0,.27.27H96c2,0,3.35,1.22,3.35,2.94s-1.31,3-3.35,3H81.5a3.17,3.17,0,0,1-3.36-3.35Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M104.09,764.3a16,16,0,0,1-.73-5.21,16.29,16.29,0,0,1,.68-5.25c1.32-4,4.8-6.21,9.47-6.21,4.84,0,8.2,2.27,9.46,6.16a15.81,15.81,0,0,1,.73,5.12,2,2,0,0,1-2.08,2.08H110a.25.25,0,0,0-.28.27,4,4,0,0,0,.23,1.27c.59,1.86,2.27,2.86,4.53,2.86a8.84,8.84,0,0,0,4.12-1.14,4.49,4.49,0,0,1,2.17-.68,2.27,2.27,0,0,1,2.31,2.36,2.63,2.63,0,0,1-1.26,2.26,13.2,13.2,0,0,1-7.93,2.36C108.8,770.55,105.36,768.24,104.09,764.3Zm13.09-7.52a.24.24,0,0,0,.27-.27,5,5,0,0,0-.23-1.63,3.56,3.56,0,0,0-3.67-2.4,3.5,3.5,0,0,0-3.62,2.4,5.34,5.34,0,0,0-.23,1.63.25.25,0,0,0,.28.27Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M130.26,768.47a2.83,2.83,0,0,1-1.54-2.54,2.59,2.59,0,0,1,2.63-2.54,3.61,3.61,0,0,1,1.85.59,10.47,10.47,0,0,0,5.39,1.59c2.31,0,3.4-.82,3.4-2,0-1-.59-1.59-3.17-1.86l-2.4-.27c-4.76-.54-7.16-2.9-7.16-6.7,0-4.3,3.31-7.07,9.06-7.07a14.87,14.87,0,0,1,6.66,1.45,2.81,2.81,0,0,1,1.86,2.49,2.4,2.4,0,0,1-2.49,2.49,4.19,4.19,0,0,1-1.82-.54,10.46,10.46,0,0,0-4.43-.95c-1.95,0-2.77.68-2.77,1.72s.55,1.54,3,1.81l2.4.27c5.16.59,7.29,3,7.29,6.66,0,4.48-3.58,7.52-9.78,7.52A15.28,15.28,0,0,1,130.26,768.47Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M166.44,742.52a3.34,3.34,0,1,1,6.66,0v8.74a.24.24,0,0,0,.27.27h10a.24.24,0,0,0,.27-.27v-8.74a3.34,3.34,0,1,1,6.66,0v24.27a3.34,3.34,0,1,1-6.66,0v-9.06a.24.24,0,0,0-.27-.27h-10a.24.24,0,0,0-.27.27v9.06a3.28,3.28,0,0,1-3.35,3.53,3.23,3.23,0,0,1-3.31-3.53Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M204.29,770.32c-5,0-6.74-2.49-6.74-7v-21a3.17,3.17,0,1,1,6.34,0v20.48c0,1.26.45,1.81,1.45,2a2.63,2.63,0,0,1,2.53,2.76c0,1.54-1,2.76-3.3,2.76Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M239.25,767V757c0-2.4-1.17-4-3.44-4s-3.4,1.59-3.4,4v10a3.17,3.17,0,1,1-6.34,0V757c0-2.4-1.17-4-3.44-4s-3.39,1.59-3.39,4v10a3.17,3.17,0,1,1-6.34,0V751.21a3.07,3.07,0,0,1,3.17-3.35,3,3,0,0,1,3,2.31h.05a7,7,0,0,1,5.79-2.54,6.76,6.76,0,0,1,5.94,2.86h0a8.7,8.7,0,0,1,6.88-2.86c5.17,0,7.79,3.36,7.79,8.15V767a3.17,3.17,0,1,1-6.34,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M253.29,765.25a2.81,2.81,0,0,1,2.71-2.08,2.75,2.75,0,0,1,2.9,2.8,2.94,2.94,0,0,1-.18,1l-2.35,7a3,3,0,0,1-2.72,2.21,2.57,2.57,0,0,1-2.67-2.8,3.81,3.81,0,0,1,.18-1.18Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M283.44,770.32c-5,0-6.74-2.49-6.74-7v-21a3.17,3.17,0,1,1,6.34,0v20.48c0,1.26.45,1.81,1.45,2a2.63,2.63,0,0,1,2.53,2.76c0,1.54-1,2.76-3.3,2.76Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M292.73,749.22A2.63,2.63,0,0,1,290,746.5a4.28,4.28,0,0,1,.18-1.09l1.36-4.34a2.71,2.71,0,0,1,2.63-2.09,2.63,2.63,0,0,1,2.76,2.72,4.28,4.28,0,0,1-.18,1.09l-1.36,4.35A2.7,2.7,0,0,1,292.73,749.22Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M315.87,767V757c0-2.4-1.18-4-3.45-4s-3.39,1.59-3.39,4v10a3.17,3.17,0,1,1-6.34,0V742.33a3.17,3.17,0,1,1,6.34,0V750h0a7.13,7.13,0,0,1,5.66-2.36c4.85,0,7.48,3.4,7.48,8.15V767a3.17,3.17,0,1,1-6.34,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M349.15,767.38a3.23,3.23,0,0,1-5.75,1.72l-.55-.77h0c-1.14,1.4-3.49,2.22-6.21,2.22-5.61,0-8.33-2.54-8.33-6.7,0-4.85,3.62-7.07,9.06-7.07h3.94a.24.24,0,0,0,.27-.27v-.23c0-2-1.45-3.26-4.49-3.26a10.46,10.46,0,0,0-3.53.64A4.9,4.9,0,0,1,332,754a2.4,2.4,0,0,1-2.54-2.53,2.78,2.78,0,0,1,1.63-2.54,15.3,15.3,0,0,1,6.7-1.27c6.62,0,9.79,3.36,9.79,8.83v6a3.8,3.8,0,0,0,.4,2.09l.59,1A3.47,3.47,0,0,1,349.15,767.38Zm-7.61-4.62v-1.5a.24.24,0,0,0-.27-.27h-3.08c-2.67,0-3.9.82-3.9,2.49s1.09,2.31,3.17,2.31C340.13,765.79,341.54,764.8,341.54,762.76Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M360.87,768h0a3,3,0,0,1-3,2.31,3.07,3.07,0,0,1-3.17-3.35V742.33a3.17,3.17,0,1,1,6.34,0V750H361c.86-1.27,2.72-2.36,5.57-2.36a7.82,7.82,0,0,1,7.61,5.57,22.91,22.91,0,0,1,0,11.78,7.82,7.82,0,0,1-7.61,5.57A6.66,6.66,0,0,1,360.87,768Zm7.25-5.34a15.83,15.83,0,0,0,0-7.16,3.34,3.34,0,0,0-3.4-2.53,3.29,3.29,0,0,0-3.35,2.53,15.83,15.83,0,0,0,0,7.16,3.3,3.3,0,0,0,3.35,2.54A3.35,3.35,0,0,0,368.12,762.67Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M380.66,742.33a3.58,3.58,0,1,1,3.58,3.58A3.55,3.55,0,0,1,380.66,742.33Zm.41,24.64V751.21a3.17,3.17,0,1,1,6.34,0V767a3.17,3.17,0,1,1-6.34,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M402.08,770.32c-5.16,0-7-2.35-7-7.33v-9.88c0-.18-.14-.27-.32-.27h-.18a2.36,2.36,0,1,1,0-4.71h.18c.18,0,.32-.09.32-.27V744.6a3.15,3.15,0,1,1,6.29,0v3.26a.24.24,0,0,0,.27.27h1.73a2.36,2.36,0,1,1,0,4.71h-1.73a.24.24,0,0,0-.27.27v9.7c0,1.31.5,1.85,1.68,2a2.77,2.77,0,0,1,2.81,2.8c0,1.54-1.09,2.72-3.49,2.72Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M431,767.38a3.23,3.23,0,0,1-5.75,1.72l-.54-.77h-.05c-1.13,1.4-3.48,2.22-6.2,2.22-5.62,0-8.33-2.54-8.33-6.7,0-4.85,3.62-7.07,9.05-7.07h3.94a.25.25,0,0,0,.28-.27v-.23c0-2-1.45-3.26-4.49-3.26a10.36,10.36,0,0,0-3.53.64,4.9,4.9,0,0,1-1.5.31,2.39,2.39,0,0,1-2.53-2.53A2.76,2.76,0,0,1,413,748.9a15.3,15.3,0,0,1,6.7-1.27c6.61,0,9.78,3.36,9.78,8.83v6a3.7,3.7,0,0,0,.41,2.09l.59,1A3.54,3.54,0,0,1,431,767.38Zm-7.6-4.62v-1.5a.25.25,0,0,0-.28-.27h-3.08c-2.67,0-3.89.82-3.89,2.49s1.09,2.31,3.17,2.31C422,765.79,423.41,764.8,423.41,762.76Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M444,770.32c-5.16,0-7-2.35-7-7.33v-9.88c0-.18-.13-.27-.32-.27h-.18a2.36,2.36,0,1,1,0-4.71h.18c.19,0,.32-.09.32-.27V744.6a3.16,3.16,0,1,1,6.3,0v3.26a.24.24,0,0,0,.27.27h1.72a2.36,2.36,0,1,1,0,4.71h-1.72a.24.24,0,0,0-.27.27v9.7c0,1.31.49,1.85,1.67,2,2,.22,2.81,1.45,2.81,2.8,0,1.54-1.09,2.72-3.49,2.72Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M464.79,764.3a16,16,0,0,1-.73-5.21,16.29,16.29,0,0,1,.68-5.25c1.32-4,4.8-6.21,9.47-6.21,4.84,0,8.2,2.27,9.46,6.16a15.81,15.81,0,0,1,.73,5.12,2,2,0,0,1-2.09,2.08H470.68c-.19,0-.28.09-.28.27a3.77,3.77,0,0,0,.23,1.27c.59,1.86,2.27,2.86,4.53,2.86a8.84,8.84,0,0,0,4.12-1.14,4.49,4.49,0,0,1,2.17-.68,2.27,2.27,0,0,1,2.31,2.36,2.63,2.63,0,0,1-1.26,2.26,13.2,13.2,0,0,1-7.93,2.36C469.5,770.55,466.06,768.24,464.79,764.3Zm13.09-7.52a.24.24,0,0,0,.27-.27,5,5,0,0,0-.23-1.63,3.56,3.56,0,0,0-3.67-2.4,3.5,3.5,0,0,0-3.62,2.4,5,5,0,0,0-.23,1.63c0,.18.09.27.28.27Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M503.69,767V757c0-2.4-1.18-4-3.44-4s-3.4,1.59-3.4,4v10a3.17,3.17,0,1,1-6.34,0V751.21a3.07,3.07,0,0,1,3.17-3.35,3,3,0,0,1,3,2.31h.05a7,7,0,0,1,5.79-2.54c4.85,0,7.48,3.4,7.48,8.15V767a3.17,3.17,0,1,1-6.34,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M529.31,743c0-2.45,1.45-4,3.67-4,2,0,3.08,1.09,4.12,3.45l6.57,14.85h.18l6.43-14.85c1-2.36,2.08-3.45,4.08-3.45,2.22,0,3.62,1.54,3.62,4v24.14a3,3,0,1,1-6.07,0V752.25h-.23l-4.75,11c-.95,2.18-1.72,2.81-3.26,2.81s-2.31-.63-3.26-2.81l-4.8-11h-.23v14.86a3,3,0,1,1-6.07,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M564.9,764.25a18.85,18.85,0,0,1,0-10.32c1.32-4,4.71-6.3,9.51-6.3s8.2,2.27,9.51,6.3a18.6,18.6,0,0,1,0,10.32c-1.31,4-4.71,6.3-9.51,6.3S566.22,768.28,564.9,764.25Zm12.91-1.49a16.63,16.63,0,0,0,0-7.34,3.58,3.58,0,0,0-6.79,0,16.63,16.63,0,0,0,0,7.34,3.58,3.58,0,0,0,6.79,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M603.71,768h0a7,7,0,0,1-5.8,2.54c-4.85,0-7.34-3.4-7.34-8.15V751.21a3.11,3.11,0,0,1,3.22-3.35,3.06,3.06,0,0,1,3.12,3.35v10c0,2.4,1.09,4,3.35,4s3.35-1.59,3.35-4v-10a3.18,3.18,0,1,1,6.35,0V767a3.08,3.08,0,0,1-3.18,3.35A3,3,0,0,1,603.71,768Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M621.55,766.43l-5.66-14.09a3.61,3.61,0,0,1-.32-1.49,3.1,3.1,0,0,1,6.07-.77l4.21,11.46h.09l4-11.46a3,3,0,0,1,6,.77,3.61,3.61,0,0,1-.32,1.49L630,766.43c-1.17,2.9-2.13,3.89-4.21,3.89S622.73,769.33,621.55,766.43Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M640.7,764.3a19.89,19.89,0,0,1,0-10.46c1.31-4,4.8-6.21,9.46-6.21,4.85,0,8.2,2.27,9.47,6.16a15.82,15.82,0,0,1,.72,5.12,2,2,0,0,1-2.08,2.08H646.59a.24.24,0,0,0-.27.27,4,4,0,0,0,.22,1.27c.59,1.86,2.27,2.86,4.53,2.86a8.77,8.77,0,0,0,4.12-1.14,4.49,4.49,0,0,1,2.18-.68,2.28,2.28,0,0,1,2.31,2.36,2.64,2.64,0,0,1-1.27,2.26,13.18,13.18,0,0,1-7.93,2.36C645.41,770.55,642,768.24,640.7,764.3Zm13.09-7.52a.24.24,0,0,0,.27-.27,5.38,5.38,0,0,0-.22-1.63,3.57,3.57,0,0,0-3.67-2.4,3.52,3.52,0,0,0-3.63,2.4,5.38,5.38,0,0,0-.22,1.63.24.24,0,0,0,.27.27Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M692.78,767V757c0-2.4-1.18-4-3.44-4s-3.4,1.59-3.4,4v10a3.17,3.17,0,1,1-6.34,0V757c0-2.4-1.18-4-3.44-4s-3.4,1.59-3.4,4v10a3.17,3.17,0,1,1-6.34,0V751.21a3.07,3.07,0,0,1,3.17-3.35,3,3,0,0,1,3,2.31h0a7,7,0,0,1,5.8-2.54,6.74,6.74,0,0,1,5.93,2.86h.05a8.68,8.68,0,0,1,6.88-2.86c5.16,0,7.79,3.36,7.79,8.15V767a3.17,3.17,0,1,1-6.34,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M705.77,764.3a16,16,0,0,1-.72-5.21,16.33,16.33,0,0,1,.67-5.25c1.32-4,4.81-6.21,9.47-6.21,4.85,0,8.2,2.27,9.46,6.16a15.81,15.81,0,0,1,.73,5.12A2,2,0,0,1,723.3,761H711.66a.24.24,0,0,0-.27.27,4,4,0,0,0,.22,1.27c.59,1.86,2.27,2.86,4.53,2.86a8.8,8.8,0,0,0,4.12-1.14,4.49,4.49,0,0,1,2.18-.68,2.28,2.28,0,0,1,2.31,2.36,2.64,2.64,0,0,1-1.27,2.26,13.2,13.2,0,0,1-7.93,2.36C710.48,770.55,707,768.24,705.77,764.3Zm13.09-7.52a.24.24,0,0,0,.27-.27,5,5,0,0,0-.23-1.63,3.55,3.55,0,0,0-3.66-2.4,3.51,3.51,0,0,0-3.63,2.4,5.38,5.38,0,0,0-.22,1.63.24.24,0,0,0,.27.27Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M744.67,767V757c0-2.4-1.18-4-3.44-4s-3.4,1.59-3.4,4v10a3.17,3.17,0,1,1-6.34,0V751.21a3.07,3.07,0,0,1,3.17-3.35,3,3,0,0,1,3,2.31h0a7,7,0,0,1,5.8-2.54c4.84,0,7.47,3.4,7.47,8.15V767a3.17,3.17,0,1,1-6.34,0Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M765.5,770.32c-5.17,0-7-2.35-7-7.33v-9.88c0-.18-.14-.27-.32-.27H758a2.36,2.36,0,1,1,0-4.71h.18c.18,0,.32-.09.32-.27V744.6a3.15,3.15,0,1,1,6.29,0v3.26a.24.24,0,0,0,.27.27h1.72a2.36,2.36,0,1,1,0,4.71H765a.24.24,0,0,0-.27.27v9.7c0,1.31.5,1.85,1.68,2a2.76,2.76,0,0,1,2.8,2.8c0,1.54-1.08,2.72-3.48,2.72Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M319.36,350.08c0-28.8-38.31-24.94-38.31-38.44,0-5.14,4-8.74,10.29-8.74a26.27,26.27,0,0,1,17,6.06,1.58,1.58,0,0,0,2.39-.34l6.4-10.36a1.59,1.59,0,0,0-.3-2c-6.46-5.49-15.08-8.62-25.09-8.62-17.74,0-28.28,11.57-28.28,25.07,0,29.05,38.44,23.65,38.44,38.82,0,5.27-4,9.51-11.83,9.51a28.15,28.15,0,0,1-19.5-7.86,1.56,1.56,0,0,0-2.4.32L261.55,364a1.58,1.58,0,0,0,.24,2c6.74,6.4,16,10.28,28.39,10.28C309.21,376.3,319.36,365,319.36,350.08Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M376,376.3c22.5,0,36-18.77,36-44.35s-13.5-44.35-36-44.35-36,18.77-36,44.35S353.42,376.3,376,376.3Zm0-73.4c11.7,0,18.26,12.47,18.26,29.05S387.74,361,376,361c-12,0-18.38-12.59-18.38-29.05S364.09,302.9,376,302.9Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M469.75,376.3c15.73,0,23.71-10.29,28.11-20A1.71,1.71,0,0,0,497,354l-11-4.78a1.74,1.74,0,0,0-2.28,1C481,356.44,476.25,361,469.75,361c-11.83,0-18.9-12.21-18.9-29.05s7.07-29.05,18.9-29.05c6.26,0,11,4,13.72,10a1.73,1.73,0,0,0,2.28.91l11.07-4.89a1.72,1.72,0,0,0,.87-2.29c-4.52-9.41-12.49-19-27.94-19-22.5,0-36.51,18.26-36.51,44.35S447.25,376.3,469.75,376.3Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M630.28,373l-24.64-82.58a2,2,0,0,0-1.88-1.39H586a2,2,0,0,0-1.87,1.39l-24.66,82.24a1.64,1.64,0,0,0,1.56,2.11h15a2,2,0,0,0,1.89-1.45L581.18,361a2,2,0,0,1,1.89-1.44h23.6a2,2,0,0,1,1.89,1.46l3.22,12.25a2,2,0,0,0,1.89,1.46H629A1.38,1.38,0,0,0,630.28,373Zm-26.8-28.57H585.9a.76.76,0,0,1-.73-1l8.73-32.88a1,1,0,0,1,1.84,0l8.75,32.53A1,1,0,0,1,603.48,344.42Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M696.87,373V361.35a1.76,1.76,0,0,0-1.76-1.76h-25.4a1.76,1.76,0,0,1-1.76-1.77v-67a1.76,1.76,0,0,0-1.77-1.76H652.49a1.76,1.76,0,0,0-1.77,1.76V373a1.77,1.77,0,0,0,1.77,1.77h42.62A1.76,1.76,0,0,0,696.87,373Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M769.88,372.8V361.54a2,2,0,0,0-2-2H738.68a.81.81,0,0,1-.81-.81V339.54a.91.91,0,0,1,.91-.91H767a2,2,0,0,0,2-1.95V325.55a2,2,0,0,0-2-2H738.57a.69.69,0,0,1-.7-.69V305.05a.87.87,0,0,1,.87-.87h29.18a2,2,0,0,0,2-1.95V291a2,2,0,0,0-2-2H722.6a2,2,0,0,0-2,2V372.8a2,2,0,0,0,2,2h45.32A2,2,0,0,0,769.88,372.8Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 443.6,
  y: 239.18,
  width: 17.23,
  height: 56.77,
  rx: 1.85,
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M530.36,308.47a10.4,10.4,0,1,0-10.4-10.4A10.4,10.4,0,0,0,530.36,308.47Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M265.31,239.5H309.1a1.43,1.43,0,0,0,1.43-1.43V225.59a1.43,1.43,0,0,0-1.43-1.43H282.72a1.43,1.43,0,0,1-1.43-1.43V154.26a1.43,1.43,0,0,0-1.43-1.43H265.31a1.43,1.43,0,0,0-1.43,1.43v83.81A1.43,1.43,0,0,0,265.31,239.5Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M413.63,241.05c19.62,0,32.1-11.43,32.1-31.57V154.62a1.8,1.8,0,0,0-1.8-1.79H430a1.79,1.79,0,0,0-1.79,1.79v55c0,10.39-5.33,16.11-14.56,16.11s-14.42-5.72-14.42-16.11v-55a1.79,1.79,0,0,0-1.79-1.79H383.47a1.79,1.79,0,0,0-1.8,1.79v54.86C381.67,229.62,394.14,241.05,413.63,241.05Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M476,239.5h13.6a1.92,1.92,0,0,0,1.91-1.91v-47.7a.85.85,0,0,1,1.6-.42l27.6,49.05a1.93,1.93,0,0,0,1.67,1h13.61a1.91,1.91,0,0,0,1.9-1.91V154.74a1.9,1.9,0,0,0-1.9-1.91h-13.6a1.9,1.9,0,0,0-1.91,1.91v45.51a.92.92,0,0,1-1.73.45l-26.44-46.9a1.9,1.9,0,0,0-1.66-1H476a1.91,1.91,0,0,0-1.91,1.91v82.85A1.92,1.92,0,0,0,476,239.5Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M644.89,241.05c22.74,0,36.38-19,36.38-44.82s-13.64-44.83-36.38-44.83-36.38,19-36.38,44.83S622,241.05,644.89,241.05Zm0-74.19c11.82,0,18.45,12.61,18.45,29.37s-6.63,29.36-18.45,29.36c-12.08,0-18.58-12.73-18.58-29.36S632.81,166.86,644.89,166.86Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 488.99,
  y: 103.52,
  width: 17.41,
  height: 57.38,
  rx: 1.87,
  fill: "#fff"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M575.84,172.7a10.51,10.51,0,1,0-10.51-10.51A10.51,10.51,0,0,0,575.84,172.7Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M708,239.5h13.6a1.91,1.91,0,0,0,1.9-1.91v-47.7a.86.86,0,0,1,1.61-.42l27.6,49.05a1.93,1.93,0,0,0,1.66,1H768a1.91,1.91,0,0,0,1.91-1.91V154.74a1.9,1.9,0,0,0-1.91-1.91h-13.6a1.9,1.9,0,0,0-1.9,1.91v45.51a.92.92,0,0,1-1.73.45L724.3,153.8a1.9,1.9,0,0,0-1.66-1H708a1.91,1.91,0,0,0-1.91,1.91v82.85A1.92,1.92,0,0,0,708,239.5Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M331.17,172.7a10.51,10.51,0,1,0-10.51-10.51A10.52,10.52,0,0,0,331.17,172.7Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M325.77,559.66H312.1a1.88,1.88,0,0,0-1.87,1.88v31.83a.73.73,0,0,1-.73.73H282.09a1,1,0,0,1-1-1V561.54a1.87,1.87,0,0,0-1.87-1.88H265.59a1.88,1.88,0,0,0-1.88,1.88v82.92a1.88,1.88,0,0,0,1.88,1.87h13.66a1.87,1.87,0,0,0,1.87-1.87v-34a1,1,0,0,1,1.05-1h27.48a.58.58,0,0,1,.58.57v34.46a1.87,1.87,0,0,0,1.87,1.87h13.67a1.87,1.87,0,0,0,1.87-1.87V561.54A1.88,1.88,0,0,0,325.77,559.66Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M486.27,601.63c7.93-2,14-9.09,14-19.88,0-11.82-7.4-22.09-23-22.09h-34.5a1.51,1.51,0,0,0-1.5,1.5v83.67a1.5,1.5,0,0,0,1.5,1.5h35.66c15.86,0,23.26-10.27,23.26-23.52C501.73,612.16,495.11,603.06,486.27,601.63ZM458.73,576.5a1.5,1.5,0,0,1,1.49-1.5h12.93c6.23,0,9.35,4,9.35,9.74,0,6-3.12,9.88-9.35,9.88H460.22a1.5,1.5,0,0,1-1.49-1.5ZM473.8,631H460.22a1.5,1.5,0,0,1-1.49-1.5V611.32a1.5,1.5,0,0,1,1.49-1.5H473.8c6.62,0,10.13,4.67,10.13,10.65C483.93,627.23,480.29,631,473.8,631Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M621.75,559.66H568.12a1.25,1.25,0,0,0-1.25,1.25v12.83a1.25,1.25,0,0,0,1.25,1.26H585a1.25,1.25,0,0,1,1.25,1.25v68.83a1.25,1.25,0,0,0,1.25,1.25h14.91a1.25,1.25,0,0,0,1.25-1.25V576.25a1.25,1.25,0,0,1,1.25-1.25h16.86a1.25,1.25,0,0,0,1.25-1.26V560.91A1.25,1.25,0,0,0,621.75,559.66Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M198,631H172.29a1.79,1.79,0,0,1-1.79-1.79V561.45a1.79,1.79,0,0,0-1.78-1.79H154.88a1.79,1.79,0,0,0-1.79,1.79v83.09a1.79,1.79,0,0,0,1.79,1.79H198a1.79,1.79,0,0,0,1.79-1.79V632.78A1.79,1.79,0,0,0,198,631Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M768.63,559.66H715a1.25,1.25,0,0,0-1.25,1.25v12.83A1.25,1.25,0,0,0,715,575h16.86a1.25,1.25,0,0,1,1.25,1.25v68.83a1.25,1.25,0,0,0,1.25,1.25h14.91a1.25,1.25,0,0,0,1.25-1.25V576.25a1.25,1.25,0,0,1,1.25-1.25h16.86a1.25,1.25,0,0,0,1.25-1.26V560.91A1.25,1.25,0,0,0,768.63,559.66Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M395.94,561.08a2,2,0,0,0-1.9-1.42h-18a2,2,0,0,0-1.9,1.41L349.25,644.2a1.65,1.65,0,0,0,1.58,2.13h15.11a2,2,0,0,0,1.91-1.46l3.36-12.41a2,2,0,0,1,1.91-1.46H397a2,2,0,0,1,1.91,1.47l3.25,12.38a2,2,0,0,0,1.92,1.48h15.45a1.38,1.38,0,0,0,1.33-1.78Zm-2.18,54.59H376a.77.77,0,0,1-.75-1l8.83-33.24a1,1,0,0,1,1.86,0l8.84,32.88A1.05,1.05,0,0,1,393.76,615.67Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M678.87,561.08a2,2,0,0,0-1.89-1.42H659a2,2,0,0,0-1.89,1.41L632.18,644.2a1.66,1.66,0,0,0,1.59,2.13h15.1a2,2,0,0,0,1.91-1.46l3.37-12.41a2,2,0,0,1,1.91-1.46h23.85a2,2,0,0,1,1.92,1.47l3.25,12.38a2,2,0,0,0,1.91,1.48h15.46a1.39,1.39,0,0,0,1.33-1.78Zm-2.18,54.59H658.92a.77.77,0,0,1-.74-1L667,581.46a1,1,0,0,1,1.86,0l8.85,32.88A1.06,1.06,0,0,1,676.69,615.67Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 447.1,
  y: 510.42,
  width: 17.41,
  height: 57.38,
  rx: 1.87,
  fill: "#fff"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M534,580.06a10.51,10.51,0,1,0-10.51-10.51A10.5,10.5,0,0,0,534,580.06Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M212.59,580.06a10.51,10.51,0,1,0-10.51-10.51A10.51,10.51,0,0,0,212.59,580.06Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M175,376.88l-20.81,13a1.29,1.29,0,0,1-2-1.09V85.3a6.61,6.61,0,0,1,6.61-6.61H582.2A2.33,2.33,0,0,1,584.54,81v20a2.33,2.33,0,0,1-2.34,2.33H178.07a1.17,1.17,0,0,0-1.16,1.17V373.42A4.09,4.09,0,0,1,175,376.88Z",
  transform: "translate(-78.14 -78.69)",
  fill: "#fff"
});

function SvgLogoBlanc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 691.74 697.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanc);
export default __webpack_public_path__ + "static/media/logo_blanc.9e24e85b.svg";
export { ForwardRef as ReactComponent };